import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Subiecte2027 from '../../components/Subiecte/Subiecte2027';
import Subiecte2026 from '../../components/Subiecte/Subiecte2026';
import Subiecte2025 from '../../components/Subiecte/Subiecte2025';
import Subiecte2024 from '../../components/Subiecte/Subiecte2024';
import Subiecte2023 from '../../components/Subiecte/Subiecte2023';
import Subiecte2022 from '../../components/Subiecte/Subiecte2022';
import Subiecte2021 from '../../components/Subiecte/Subiecte2021';
import TesteAntrenament2021 from '../../components/Subiecte/TesteAntrenament2021';
import Subiecte2020 from '../../components/Subiecte/Subiecte2020';
import TesteAntrenament2020 from '../../components/Subiecte/TesteAntrenament2020';
import Subiecte2019 from '../../components/Subiecte/Subiecte2019';
import Subiecte2018 from '../../components/Subiecte/Subiecte2018';
import Subiecte2017 from '../../components/Subiecte/Subiecte2017';
import Subiecte2016 from '../../components/Subiecte/Subiecte2016';
import Subiecte2015 from '../../components/Subiecte/Subiecte2015';
import Subiecte2014 from '../../components/Subiecte/Subiecte2014';
import Subiecte2013 from '../../components/Subiecte/Subiecte2013';
import Subiecte2012 from '../../components/Subiecte/Subiecte2012';
import Subiecte2011 from '../../components/Subiecte/Subiecte2011';
import Subiecte2010 from '../../components/Subiecte/Subiecte2010';
import Subiecte2009 from '../../components/Subiecte/Subiecte2009';

import './Subiecte.css';

export default function Subiecte() {
    const { yearId } = useParams();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    const currentYear = yearId || "2027";

    const componentsMap = {
        "2027": <Subiecte2027/>,
        "2026": <Subiecte2026/>,
        "2025": <Subiecte2025/>,
        "2024": <Subiecte2024/>,
        "2023": <Subiecte2023/>,
        "2022": <Subiecte2022/>,
        "2021": <Subiecte2021/>,
        "teste-2021": <TesteAntrenament2021/>,
        "2020": <Subiecte2020/>,
        "teste-2020": <TesteAntrenament2020/>,
        "2019": <Subiecte2019/>,
        "2018": <Subiecte2018/>,
        "2017": <Subiecte2017/>,
        "2016": <Subiecte2016/>,
        "2015": <Subiecte2015/>,
        "2014": <Subiecte2014/>,
        "2013": <Subiecte2013/>,
        "2012": <Subiecte2012/>,
        "2011": <Subiecte2011/>,
        "2010": <Subiecte2010/>,
        "2009": <Subiecte2009/>,
    };

    const subjectsList = [
        { id: "2027", label: "Subiecte 2027" },
        { id: "2026", label: "Subiecte 2026" },
        { id: "2025", label: "Subiecte 2025" },
        { id: "2024", label: "Subiecte 2024" },
        { id: "2023", label: "Subiecte 2023" },
        { id: "2022", label: "Subiecte 2022" },
        { id: "2021", label: "Subiecte 2021" },
        { id: "teste-2021", label: "Teste Antrenament 2021" },
        { id: "2020", label: "Subiecte 2020" },
        { id: "teste-2020", label: "Teste Antrenament 2020" },
        { id: "2019", label: "Subiecte 2019" },
        { id: "2018", label: "Subiecte 2018" },
        { id: "2017", label: "Subiecte 2017" },
        { id: "2016", label: "Subiecte 2016" },
        { id: "2015", label: "Subiecte 2015" },
        { id: "2014", label: "Subiecte 2014" },
        { id: "2013", label: "Subiecte 2013" },
        { id: "2012", label: "Subiecte 2012" },
        { id: "2011", label: "Subiecte 2011" },
        { id: "2010", label: "Subiecte 2010" },
        { id: "2009", label: "Subiecte 2009" },
    ];

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 990);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const titles = document.querySelectorAll('.subjectTitle');
        titles.forEach((el) => {
            if (!el.querySelector('.bracket') && el.textContent.includes('<')) {
                el.innerHTML = el.textContent
                    .replace(/^</, '<span class="bracket">&lt;</span>')
                    .replace(/\/>$/, '<span class="bracket">/&gt;</span>');
            }
        });
    }, [currentYear]);

    const handleYearChange = (id) => {
        navigate(`/subiecte/${id}`);
    };

    return (
        <Container className="subjectContainer worldwide">
            <Row>
                {isMobile ? (
                    <Col xs={12} style={{ marginBottom: "20px" }}>
                        <select
                            className="form-select"
                            value={currentYear}
                            onChange={(e) => handleYearChange(e.target.value)}
                        >
                            {subjectsList.map(item => (
                                <option key={item.id} value={item.id}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </Col>
                ) : (
                    <Col lg={3} style={{ marginTop: "25px", borderRight: "1px solid #FFFFFF"}} className="subjectMenu" >
                        {subjectsList.map((item, index) => (
                            <div key={item.id}>
                                <span 
                                    onClick={() => handleYearChange(item.id)} 
                                    className={`subjectSelection ${currentYear === item.id ? 'active' : ''}`}
                                    style={{ cursor: 'pointer', display: 'inline-block' }}
                                >
                                    {item.label}
                                </span>
                                {index < subjectsList.length - 1 && <br />}
                            </div>
                        ))}
                    </Col>
                )}
                <Col lg={isMobile ? 12 : 9} className="subjectList">
                    {componentsMap[currentYear] || componentsMap["2026"]}
                </Col>
            </Row>
        </Container>
    );
}